export default "__VITE_ASSET__354d86c4__"